import { ClientSelector, init, StorageAdapterLS } from "@opendash/core";
import { getCurrentLanguageSync } from "@opendash/i18n";
import { registerIconPack } from "@opendash/icons";
import { $parse, ParsePlugin } from "@opendash/plugin-parse";
import dayjs from "dayjs";
import { GlobalStyles } from "./GlobalStyles";

import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import Parse from "parse";
import { MetaPlugin } from "@opendash/plugin-meta";

init("opendash", async (factory) => {
  const clientselector = ClientSelector.getInstance();

  Parse.initialize(clientselector.getParseAppId(), "");
  Parse.serverURL = clientselector.getParseHost();

  registerIconPack(await import("@opendash/icons/dist/fa-regular.json"));
  registerIconPack(await import("@opendash/icons/dist/fa-solid.json"));
  registerIconPack(await import("@opendash/icons/dist/fa-light.json"));

  factory.ui.setLogoImage(clientselector.getLogoImage());

  factory.registerGlobalComponent(GlobalStyles, {});

  // Translations
  factory.registerLanguage("en", "English");
  factory.registerLanguage("de", "Deutsch", "en", true);

  factory.registerAntDesignTranslation(
    "en",
    () => import("antd/lib/locale/en_US"),
  );

  factory.registerAntDesignTranslation(
    "de",
    () => import("antd/lib/locale/de_DE"),
  );

  factory.registerTranslationResolver(
    "de",
    "example",
    async () => await import("./i18n/de.json"),
  );

  factory.registerTranslationResolver(
    "en",
    "example",
    async () => await import("./i18n/en.json"),
  );

  // Adapter + Plugins
  factory.registerDeviceStorageAdapter(new StorageAdapterLS());

  await factory.use(
    new ParsePlugin({
      authLdapActive: false,
      useLiveQueries: false,
    }),
  );

  await factory.use(new MetaPlugin());

  // Class Config

  // $parse.ui.setDefaultView(SIV_Order.className, {
  //   type: "table",
  //   showSearch: true,
  // });

  // $parse.ui.setClassConfig<SIV_Order>({
  //   className: Example.className,
  //   translationPrefix: "example:classes.",
  //   titleFields: ["no"],
  //   displayFields: [
  //     "example"
  //   ],
  //   createFields: [],
  //   editFields: [],
  // });

  // Navigation

  // factory.registerStaticNavigationGroup({
  //   id: "example-group",
  //   label: "Example",
  //   order: 100,
  //   icon: "fa-solid:building-shield",
  // });

  // factory.registerStaticNavigationItem({
  //   id: "example-dashboard",
  //   group: "example-group",
  //   label: "Example",
  //   order: 1,
  //   icon: "fa:clipboard",
  //   activeCondition: "",
  //   place: "frontpage",
  //   routeCondition: "/",
  //   permission: [],
  //   link: "/orders",
  //   color: "#0081C7",
  // });
}).then((app) => {
  console.log("init open.DASH");
  dayjs.locale(getCurrentLanguageSync());
  dayjs.extend(utc);
  dayjs.extend(timezone);
  dayjs.tz.setDefault("Europe/Berlin");
});
